import React from 'react';
import ProjectItem from '../../../Domain/ProjectItem';
import OrderDirectionsEnum from '../../../Enums/OrderDirectionsEnum';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import OperationsProjectService from '../../../Services/OperationsProjectService';
import ProjectSearchParams from './ProjectSearchParams';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import EditProjectWindowDescription from './EditProjectWindowDescription';
import ErrorMessage from '../../../Elements/ErrorMessage';
import Loading from '../../../Elements/loading';

class ProjectAdmin extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);

    this.state = {
      itemList: [],
      selected: -1,
      selectedItem: null,
      orderBy: 'CfEndDate',
      orderDirection: OrderDirectionsEnum.Desc,
      shownPanel: ShownPanelsEnum.None,
      searchItem: new ProjectSearchParams(),
      loading: false,
    };
    this.showPanel = this.showPanel.bind(this);
    this.startSearch = this.startSearch.bind(this);
    ProjectItem.editFunction = this.clickOnEditIcon.bind(this);
  }

  componentDidMount() {
    // M: Start the search if there are any search parameters in the URL.
    if (JSON.stringify(this.state.searchItem) !== JSON.stringify(new ProjectSearchParams(true))) {
      this.startSearch(this.state.searchItem);
    }
  }

  showPanel(panelId) {
    if (panelId === ShownPanelsEnum.Refresh) {
      this.refresh();
      panelId = ShownPanelsEnum.None;
    }
    panelId = panelId === this.state.shownPanel ? ShownPanelsEnum.None : panelId;
    this.setState({ shownPanel: panelId });
  }

  async clickOnEditIcon(selectedId, selectedItem) {
    this.setState({ loading: true });
    OperationsProjectService.GetIsProjectInvoicedById(selectedItem.CfId)
      .then((isInvoiced) => {
        this.setState({
          selectedItem: { ...selectedItem, IsInvoiced: isInvoiced },
          shownPanel: ShownPanelsEnum.EditItem,
          loading: false,
        });
      })
      .catch(() => {
        ErrorMessage.SetErrorMessage(
          "PA62 - Can't get project invoiced status. You won't be able to edit the reimbursement type."
        );
        this.setState({
          selectedItem: { ...selectedItem, IsInvoiced: true },
          shownPanel: ShownPanelsEnum.EditItem,
          loading: false,
        });
      });
  }

  refresh() {
    this.setState({ searchItem: { ...this.state.searchItem } });
  }

  renderPanels() {
    return (
      <div>
        {this.renderOnePanel(
          ShownPanelsEnum.EditItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedItem}
            clickOnCancel={this.editPanelOnClose.bind(this)}
            clickOnSave={this.savePanelOnClose.bind(this)}
            windowDescription={EditProjectWindowDescription}
            errorCode={'OA74'}
          />
        )}
      </div>
    );
  }

  editPanelOnClose(refresh) {
    this.setState({ shownPanel: ShownPanelsEnum.None });
    if (refresh) {
      this.refresh();
    }
  }

  savePanelOnClose() {
    this.setState({
      shownPanel: ShownPanelsEnum.None,
    });
    this.refresh();
  }

  renderOnePanel(panelId, content) {
    return this.state.shownPanel === panelId ? content : null;
  }

  startSearch(searchItem) {
    this.setState({
      searchItem,
    });
  }

  render() {
    return this.state.loading ? (
      <Loading />
    ) : (
      <div className='contentwrapper'>
        {this.renderPanels()}
        <TabOfDataTable
          type={ProjectItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={OperationsProjectService.GetProjectList}
          convertDBItemsFunction={OperationsProjectService.ConvertDBItemList}
          searchItem={this.state.searchItem}
          orderBy={this.state.orderBy}
          orderDirection={this.state.orderDirection}
          showSearchStrip={true}
          searchParamsType={ProjectSearchParams}
          clickOnStartSearch={(searchItem) => this.setState({ searchItem })}
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in different ids and names...'
          errorCode='PA125'
        />
      </div>
    );
  }
}

export default ProjectAdmin;
